import { openBlock as o, createElementBlock as r, normalizeClass as u, createElementVNode as a, toDisplayString as f, createCommentVNode as m, renderSlot as g, normalizeStyle as k, Fragment as X, renderList as A, withModifiers as S, createBlock as B, resolveDynamicComponent as w, createTextVNode as I } from "vue";
function z(t) {
  return new Promise((i, e) => {
    let n = !1, c = document.querySelector(`script[src^="${t}"]`);
    if (!c)
      c = document.createElement("script"), c.async = !0, c.src = t, n = !0;
    else {
      i(c);
      return;
    }
    c.addEventListener("error", e), c.addEventListener("abort", e), c.addEventListener("load", () => {
      c.dataset.loaded = "loaded", i(c);
    }), n && document.head.append(c);
  });
}
function P(...t) {
  const i = t.reduce((e, n) => (typeof n == "string" && e.push(n), Array.isArray(n) && e.push(...n), e), []);
  return Promise.allSettled(i.flat(1 / 0).map(z));
}
function O(t) {
  const i = {
    GB: 1073741824,
    MB: 1048576,
    KB: 1024
  }, e = (c) => [(t / i[c]).toFixed(2), c].join(" ");
  let n = 0;
  return t >= i.GB ? n = e("GB") : t >= i.MB ? n = e("MB") : t >= i.KB ? n = e("KB") : n = [t, "B"].join(" "), n;
}
var x = { exports: {} };
x.exports = C;
x.exports.isMobile = C;
x.exports.default = C;
const L = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, j = /CrOS/, D = /android|ipad|playbook|silk/i;
function C(t) {
  t || (t = {});
  let i = t.ua;
  if (!i && typeof navigator < "u" && (i = navigator.userAgent), i && i.headers && typeof i.headers["user-agent"] == "string" && (i = i.headers["user-agent"]), typeof i != "string")
    return !1;
  let e = L.test(i) && !j.test(i) || !!t.tablet && D.test(i);
  return !e && t.tablet && t.featureDetect && navigator && navigator.maxTouchPoints > 1 && i.indexOf("Macintosh") !== -1 && i.indexOf("Safari") !== -1 && (e = !0), e;
}
class R {
  constructor(i) {
    this.BX24 = i;
  }
  init() {
    return new Promise((i) => {
      this.BX24.init(i);
    });
  }
  install(i) {
    return typeof i == "string" ? (this.BX24.install(i), Promise.resolve()) : new Promise((e) => {
      this.BX24.install(e);
    });
  }
  installFinish() {
    this.BX24.installFinish();
  }
  getAuth() {
    return this.BX24.getAuth();
  }
  refreshAuth() {
    return new Promise((i) => {
      this.BX24.refreshAuth(i);
    });
  }
  callMethod(i, e, n) {
    this.BX24.callMethod(i, e, n);
  }
  callBatch(i, e) {
    return new Promise((n) => {
      this.BX24.callBatch(i, n, e);
    });
  }
  callBind(i, e, n, c) {
    return this.BX24.callBind(i, e, n, c), this.callUnbind.bind(this, i, e, n, c);
  }
  callUnbind(i, e, n, c) {
    this.BX24.callUnbind(i, e, n, c);
  }
  get userOption() {
    return {
      set: (i, e) => {
        this.BX24.userOption.set(i, e);
      },
      get: (i) => this.BX24.userOption.get(i)
    };
  }
  get appOption() {
    return {
      set: (i, e) => new Promise((n) => {
        this.BX24.appOption.set(i, e, n);
      }),
      get: (i) => this.BX24.appOption.get(i)
    };
  }
  selectUser() {
    return new Promise((i) => {
      this.BX24.selectUser(i);
    });
  }
  selectUsers() {
    return new Promise((i) => {
      this.BX24.selectUsers(i);
    });
  }
  selectAccess(i) {
    return new Promise((e) => {
      Array.isArray(i) ? this.BX24.selectAccess(i, e) : this.BX24.selectAccess(e);
    });
  }
  selectCRM(i = {}) {
    return new Promise((e) => {
      this.BX24.selectCRM(i, e);
    });
  }
  get placement() {
    return {
      bindEvent: (i) => new Promise((e) => {
        this.BX24.placement.bindEvent(i, e);
      }),
      call: (i, e) => new Promise((n) => {
        this.BX24.placement.call(i, e, n);
      }),
      getInterface: () => new Promise((i) => {
        this.BX24.placement.getInterface(i);
      }),
      info: () => this.BX24.placement.info()
    };
  }
  isAdmin() {
    return this.BX24.isAdmin();
  }
  getLang() {
    return this.BX24.getLang();
  }
  resizeWindow(i, e) {
    return new Promise((n) => {
      this.BX24.resizeWindow(i, e, n);
    });
  }
  fitWindow() {
    return new Promise((i) => {
      this.BX24.fitWindow(i);
    });
  }
  reloadWindow() {
    this.BX24.reloadWindow();
  }
  setTitle(i = "") {
    return new Promise((e) => {
      this.BX24.setTitle(i, e);
    });
  }
  ready() {
    return new Promise((i) => {
      this.BX24.ready(i);
    });
  }
  isReady() {
    return this.BX24.isReady();
  }
  proxy(i, e) {
    return this.BX24.proxy(i, e);
  }
  closeApplication() {
    this.BX24.closeApplication();
  }
  getDomain(i) {
    const e = this.BX24.getDomain();
    return i ? ["https:", e].join("//") : e;
  }
  openApplication(i) {
    return new Promise((e) => {
      this.BX24.openApplication(i, e);
    });
  }
  openPath(i) {
    return new Promise((e, n) => {
      this.BX24.openPath(i, (c) => {
        c.result === "error" && n(new Error(c.errorCode)), e(i);
      });
    });
  }
  proxyContext() {
    return this.BX24.proxyContext();
  }
  scrollParentWindow(i) {
    return new Promise((e) => {
      this.BX24.scrollParentWindow(i, e);
    });
  }
  bind(i, e, n) {
    return this.BX24.bind(i, e, n), this.unbind.bind(this, i, e, n);
  }
  unbind(i, e, n) {
    this.BX24.unbind(i, e, n);
  }
  getScrollSize() {
    return this.BX24.getScrollSize();
  }
  loadScript(...i) {
    return z(...i);
  }
  get im() {
    return {
      callTo: (i, e) => {
        this.BX24.im.callTo(i, e);
      },
      phoneTo: (i) => {
        this.BX24.im.phoneTo(i);
      },
      openMessenger: (i) => {
        this.BX24.im.openMessenger(i);
      },
      openHistory: (i) => {
        this.BX24.im.openHistory(i);
      }
    };
  }
}
class T {
  constructor(i, e = {}) {
    this.callBatch = i, this.handler = e, this.commands = [], this.result = {}, this.errors = {}, this.delay = 500, this.limit = 50;
  }
  batch(i) {
    return this.commands = [], this.result = {}, this.errors = {}, new Promise((e, n) => {
      const c = this.parseRequest(i), l = [];
      let s = 0;
      this.callBatch(c, (d) => {
        Object.entries(d).forEach(([h, p]) => {
          const b = p.error();
          b && (this.errors[h] = b, s += 1);
          const _ = p.total(), y = p.data(), V = y ? y != null && y.items ? y.items.length : y.length : 1;
          if (this.result[h] = y, _ > this.limit && _ > V) {
            const E = Math.ceil(_ / this.limit) - 1, M = Array.from({ length: E });
            l.push([h, c[h], M]);
          }
        }), s > 0 ? (this.errorLogger(), n(this.errors)) : l.length ? (this.buildCommandsArray(l), this.batchPayload().then(() => e(this.parseResult()))) : e(this.parseResult());
      });
    });
  }
  buildCommandsArray(i) {
    let e = [];
    i.forEach(([n, c, l]) => {
      l.forEach((s, d) => {
        const h = d + 1, p = this.limit * h, _ = [[n, h].join("_"), this.addStart(c, p)];
        e.length === this.limit ? (this.commands.push(e), e = [_]) : e.push(_);
      });
    }), e.length && this.commands.push(e);
  }
  batchPayload() {
    const i = [];
    return this.commands.forEach((e) => {
      const n = Object.fromEntries(e), c = new Promise((l) => {
        setTimeout(() => {
          this.callBatch(n, (s) => {
            Object.entries(s).forEach(([d, h]) => {
              const [p] = d.split("_"), b = h.data();
              b != null && b.items ? this.result[p].items.push(...b.items) : Array.isArray(b) && this.result[p].push(...b);
            }), l();
          });
        }, this.delay);
      });
      i.push(c);
    }), Promise.all(i);
  }
  parseResult() {
    return Object.entries(this.handler).forEach(([i, e]) => {
      this.result[i] && (this.result[i] = e(this.result[i]));
    }), this.result;
  }
  parseRequest(i) {
    return Object.entries(i).reduce((e, [n, c]) => {
      if (Array.isArray(c)) {
        const [l, s = {}] = c;
        e[n] = [l, s];
      } else {
        const { method: l, params: s = {} } = c;
        e[n] = [l, s];
      }
      return e;
    }, {});
  }
  addStart(i, e) {
    const [n, c] = i;
    return [n, { start: e, ...c }];
  }
  errorLogger() {
    console.group(`${this.constructor.name}: \u041E\u0448\u0438\u0431\u043A\u0438 \u0432 \u043C\u0435\u0442\u043E\u0434\u0430\u0445!`), Object.entries(this.errors).forEach(([i, e]) => {
      console.info(`[${i}]`, e.toString());
    }), console.groupEnd();
  }
}
class W extends R {
  appInfo() {
    return this.createBatch().batch({
      appInfo: ["app.info"],
      profile: ["profile"],
      scope: ["scope"]
    }).then((e) => (e.placementInfo = this.placement.info(), e));
  }
  createBatch(i = {}, e = T) {
    return new e(this.BX24.callBatch, i);
  }
  isMobile() {
    return x.exports();
  }
  loadScripts(...i) {
    return P(...i);
  }
  openLink(i, e = "_blank") {
    const n = () => {
      const c = [this.getDomain(!0), i].join("");
      window.open(c, e);
    };
    x.exports() ? n() : this.openPath(i).catch(n);
  }
}
const ai = {
  init(...t) {
    return P("//api.bitrix24.com/api/v1/", ...t).then(() => {
      if (window.BX24) {
        this.initAssets(window.BX24.getDomain());
        const i = new W(window.BX24);
        return i.init().then(() => i);
      }
      return this.initAssets(), Promise.resolve({});
    });
  },
  initAssets(t = "www.bitrix24.ru") {
    const i = `//${t}/bitrix/js/ui`, n = [
      "alerts/ui.alerts.min.css",
      "buttons/ui.buttons.min.css",
      "buttons/icons/ui.buttons.icons.min.css",
      "fonts/opensans/ui.font.opensans.min.css",
      "forms/ui.forms.min.css",
      "icons/b24/ui.icons.b24.min.css",
      "icons/base/ui.icons.base.min.css",
      "icons/disk/ui.icons.disk.min.css",
      "icons/service/ui.icons.service.min.css",
      "progressbar/ui.progressbar.min.css"
    ].reduce((c, l) => {
      const s = document.createElement("link");
      return s.rel = "stylesheet", s.href = [i, l].join("/"), c.append(s), c;
    }, new DocumentFragment());
    document.head.prepend(n);
  }
}, v = (t, i) => {
  const e = t.__vccOpts || t;
  for (const [n, c] of i)
    e[n] = c;
  return e;
}, F = {
  emits: ["close"],
  props: {
    title: {
      type: String,
      default: "\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435!"
    },
    size: {
      type: String,
      default: "md"
    },
    color: {
      type: String,
      default: "default"
    },
    icon: {
      type: String,
      default: ""
    },
    center: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-alert"
}, U = { class: "ui-alert-message" }, N = { key: 0 };
function K(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-alert", {
      "ui-alert-md": e.size === "md",
      "ui-alert-xs": e.size === "xs",
      "ui-alert-default": e.color === "default",
      "ui-alert-primary": e.color === "primary",
      "ui-alert-success": e.color === "success",
      "ui-alert-warning": e.color === "warning",
      "ui-alert-danger": e.color === "danger",
      "ui-alert-icon-warning": e.icon === "warning",
      "ui-alert-icon-danger": e.icon === "danger",
      "ui-alert-icon-info": e.icon === "info",
      "ui-alert-text-center": e.center,
      "ui-alert-inline": e.inline
    }])
  }, [
    a("span", U, [
      e.title ? (o(), r("strong", N, f(e.title), 1)) : m("", !0),
      g(t.$slots, "default")
    ]),
    a("span", {
      class: "ui-alert-close-btn",
      onClick: i[0] || (i[0] = (s) => t.$emit("close"))
    })
  ], 2);
}
const ui = /* @__PURE__ */ v(F, [["render", K]]), G = {
  computed: {
    classList() {
      const t = [
        "default",
        "success",
        "success-light",
        "danger",
        "danger-dark",
        "danger-light",
        "primary",
        "primary-dark",
        "secondary",
        "link",
        "light",
        "light-border"
      ], i = [
        "add",
        "stop",
        "start",
        "pause",
        "setting",
        "task",
        "info",
        "search",
        "follow",
        "unfollow",
        "print",
        "add-folder",
        "list",
        "business",
        "business-confirm",
        "business-warning",
        "camera",
        "phone-up",
        "phone-down",
        "back",
        "edit",
        "share",
        "remove",
        "download",
        "cloud",
        "page",
        "chat",
        "phone-call",
        "lock",
        "done",
        "disk",
        "mail",
        "alert",
        "angle-up",
        "angle-down",
        "dots",
        "forward",
        "fail",
        "success",
        "plan",
        "eye-opened",
        "eye-closed",
        "tariff",
        "battery",
        "no-battery",
        "half-battery",
        "low-battery",
        "crit-battery",
        "demo"
      ];
      return {
        "ui-btn-disabled": this.disabled,
        "ui-btn-dropdown": this.dropdown,
        "ui-btn-round": this.round,
        "ui-btn-no-caps": this.noCaps,
        "ui-btn-clock": this.loader === "clock",
        "ui-btn-wait": this.loader === "wait",
        "ui-btn-xs": this.size === "xs",
        "ui-btn-sm": this.size === "sm",
        "ui-btn-md": this.size === "md",
        "ui-btn-lg": this.size === "lg",
        [`ui-btn-${this.color}`]: t.includes(this.color),
        [`ui-btn-icon-${this.icon}`]: i.includes(this.icon)
      };
    }
  },
  emits: ["click", "toggle-menu"],
  props: {
    type: {
      type: String,
      default: "button"
    },
    color: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "md"
    },
    icon: {
      type: String,
      default: ""
    },
    loader: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    },
    counter: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    dropdown: {
      type: Boolean,
      default: !1
    },
    round: {
      type: Boolean,
      default: !1
    },
    noCaps: {
      type: Boolean,
      default: !1
    },
    menu: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-button"
}, q = ["type"], H = {
  key: 0,
  class: "ui-btn-counter"
}, $ = ["type"], J = {
  key: 0,
  class: "ui-btn-counter"
};
function Q(t, i, e, n, c, l) {
  return e.menu ? (o(), r("div", {
    key: 0,
    class: u(["ui-btn-split", l.classList])
  }, [
    a("button", {
      class: "ui-btn-main",
      type: e.type,
      onClick: i[0] || (i[0] = (s) => t.$emit("click"))
    }, [
      g(t.$slots, "default"),
      e.counter ? (o(), r("i", H, f(e.count), 1)) : m("", !0)
    ], 8, q),
    a("button", {
      class: "ui-btn-menu",
      type: "button",
      onClick: i[1] || (i[1] = (s) => t.$emit("toggle-menu"))
    })
  ], 2)) : (o(), r("button", {
    key: 1,
    class: u(["ui-btn", l.classList]),
    type: e.type,
    onClick: i[2] || (i[2] = (s) => t.$emit("click"))
  }, [
    g(t.$slots, "default"),
    e.counter ? (o(), r("i", J, f(e.count), 1)) : m("", !0)
  ], 10, $));
}
const di = /* @__PURE__ */ v(G, [["render", Q]]);
const Y = {
  props: {
    center: {
      type: Boolean,
      default: !1
    },
    right: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-button-wrapper"
};
function Z(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-btn-container", {
      "ui-btn-container-center": e.center,
      "ui-btn-container-right": e.right
    }])
  }, [
    g(t.$slots, "default")
  ], 2);
}
const hi = /* @__PURE__ */ v(Y, [["render", Z]]);
const ee = {
  methods: {
    updateInput(t) {
      const i = t.target.checked;
      if (Array.isArray(this.modelValue)) {
        const e = [...this.modelValue];
        i ? e.push(this.value) : e.splice(e.indexOf(this.value), 1), this.$emit("update:modelValue", e);
      } else
        this.$emit("update:modelValue", Boolean(i));
    }
  },
  computed: {
    isChecked() {
      return Array.isArray(this.modelValue) ? this.modelValue.includes(this.value) : this.modelValue === !0;
    }
  },
  emits: ["update:modelValue"],
  props: {
    value: {
      type: [Boolean, String, Array, Object],
      default: ""
    },
    modelValue: {
      type: [Boolean, String, Array, Object],
      default: ""
    },
    width: {
      type: String,
      default: "320px"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    old: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-checkbox"
}, ie = { class: "checkbox-label" }, te = ["checked", "value", "disabled"], ne = /* @__PURE__ */ a("span", { class: "checkbox-mark" }, null, -1), se = ["checked", "value", "disabled"], ce = { class: "ui-ctl-label-text" };
function le(t, i, e, n, c, l) {
  return e.old ? (o(), r("label", {
    key: 0,
    class: "checkbox-container",
    style: k({ width: e.width })
  }, [
    a("div", ie, [
      g(t.$slots, "default")
    ]),
    a("input", {
      type: "checkbox",
      checked: l.isChecked,
      value: e.value,
      disabled: e.disabled,
      onChange: i[0] || (i[0] = (...s) => l.updateInput && l.updateInput(...s))
    }, null, 40, te),
    ne
  ], 4)) : (o(), r("label", {
    key: 1,
    class: "ui-ctl ui-ctl-checkbox",
    style: k({ width: e.width })
  }, [
    a("input", {
      class: "ui-ctl-element",
      type: "checkbox",
      checked: l.isChecked,
      value: e.value,
      disabled: e.disabled,
      onChange: i[1] || (i[1] = (...s) => l.updateInput && l.updateInput(...s))
    }, null, 40, se),
    a("div", ce, [
      g(t.$slots, "default")
    ])
  ], 4));
}
const gi = /* @__PURE__ */ v(ee, [["render", le]]);
const oe = {
  data() {
    return {
      hoverDelete: []
    };
  },
  emits: ["add", "auxclick", "click", "delete"],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    displayField: {
      type: String,
      default: "name"
    },
    textAdd: {
      type: String,
      default: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
    },
    textMore: {
      type: String,
      default: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0435\u0449\u0451"
    },
    textChange: {
      type: String,
      default: "\u0421\u043C\u0435\u043D\u0438\u0442\u044C"
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-entity-selector"
}, re = { class: "bx-entity-selector__button" }, ae = { class: "bx-entity-selector__items" }, ue = ["onAuxclick", "onClick"], de = ["onMouseenter", "onMouseleave", "onClick"], he = { class: "bx-entity-selector__controls" }, ge = { class: "bx-entity-selector__content" };
function ve(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["bx-entity-selector", { inline: e.inline }])
  }, [
    a("div", re, [
      a("span", ae, [
        (o(!0), r(X, null, A(e.list, (s, d) => (o(), r("span", {
          key: d,
          class: u(["bx-entity-selector__item", { "hover-delete": c.hoverDelete[d] }])
        }, [
          a("span", {
            class: u(["bx-entity-selector__text", { clickable: e.clickable }]),
            onAuxclick: S((h) => e.clickable ? t.$emit("auxclick", d, s) : !1, ["prevent"]),
            onClick: S((h) => e.clickable ? t.$emit("click", d, s) : !1, ["prevent"])
          }, f(s[e.displayField]), 43, ue),
          a("button", {
            class: "bx-entity-selector__delete",
            onMouseenter: (h) => c.hoverDelete[d] = !0,
            onMouseleave: (h) => c.hoverDelete[d] = !1,
            onClick: (h) => t.$emit("delete", d, s)
          }, null, 40, de)
        ], 2))), 128))
      ]),
      a("span", he, [
        a("button", {
          class: "bx-entity-selector__add",
          onClick: i[0] || (i[0] = (s) => t.$emit("add"))
        }, f(e.list.length ? e.multiple ? e.textMore : e.textChange : e.textAdd), 1)
      ])
    ]),
    a("div", ge, [
      g(t.$slots, "default")
    ])
  ], 2);
}
const vi = /* @__PURE__ */ v(oe, [["render", ve]]);
const fe = {
  computed: {
    classList() {
      return {
        "ui-icon-file-empty": this.icon === "file-empty",
        "ui-icon-file-txt": this.icon === "file-txt",
        "ui-icon-file-doc": this.icon === "file-doc",
        "ui-icon-file-xls": this.icon === "file-xls",
        "ui-icon-file-php": this.icon === "file-php",
        "ui-icon-file-pdf": this.icon === "file-pdf",
        "ui-icon-file-ppt": this.icon === "file-ppt",
        "ui-icon-file-rar": this.icon === "file-rar",
        "ui-icon-file-zip": this.icon === "file-zip",
        "ui-icon-file-set": this.icon === "file-set",
        "ui-icon-file-img": this.icon === "file-img",
        "ui-icon-file-mov": this.icon === "file-mov",
        "ui-icon-file-folder": this.icon === "file-folder",
        "ui-icon-file-folder-shared": this.icon === "file-folder-shared",
        "ui-icon-file-folder-shared-2": this.icon === "file-folder-shared-2",
        "ui-icon-common-user": this.icon === "common-user",
        "ui-icon-common-user-group": this.icon === "common-user-group",
        "ui-icon-common-company": this.icon === "common-company",
        "ui-icon-common-phone": this.icon === "common-phone",
        "ui-icon-common-notification": this.icon === "common-notification",
        "ui-icon-common-bitrix24": this.icon === "common-bitrix24",
        "ui-icon-common-cloud": this.icon === "common-cloud",
        "ui-icon-common-folder": this.icon === "common-folder",
        "ui-icon-common-info": this.icon === "common-info",
        "ui-icon-service-alice": this.icon === "service-alice",
        "ui-icon-service-light-alice": this.icon === "service-light-alice",
        "ui-icon-service-fb-instagram": this.icon === "service-fb-instagram",
        "ui-icon-service-light-fb-instagram": this.icon === "service-light-fb-instagram",
        "ui-icon-service-instagram-fb": this.icon === "service-instagram-fb",
        "ui-icon-service-light-instagram-fb": this.icon === "service-light-instagram-fb",
        "ui-icon-service-instagram": this.icon === "service-instagram",
        "ui-icon-service-light-instagram": this.icon === "service-light-instagram",
        "ui-icon-service-twilio": this.icon === "service-twilio",
        "ui-icon-service-light-twilio": this.icon === "service-light-twilio",
        "ui-icon-service-callback": this.icon === "service-callback",
        "ui-icon-service-light-callback": this.icon === "service-light-callback",
        "ui-icon-service-livechat": this.icon === "service-livechat",
        "ui-icon-service-light-livechat": this.icon === "service-light-livechat",
        "ui-icon-service-liveid": this.icon === "service-liveid",
        "ui-icon-service-light-liveid": this.icon === "service-light-liveid",
        "ui-icon-service-ya": this.icon === "service-ya",
        "ui-icon-service-light-ya": this.icon === "service-light-ya",
        "ui-icon-service-ya-dialogs": this.icon === "service-ya-dialogs",
        "ui-icon-service-light-ya-dialogs": this.icon === "service-light-ya-dialogs",
        "ui-icon-service-ya-direct": this.icon === "service-ya-direct",
        "ui-icon-service-light-ya-direct": this.icon === "service-light-ya-direct",
        "ui-icon-service-1c": this.icon === "service-1c",
        "ui-icon-service-light-1c": this.icon === "service-light-1c",
        "ui-icon-service-google": this.icon === "service-google",
        "ui-icon-service-light-google": this.icon === "service-light-google",
        "ui-icon-service-google-ads": this.icon === "service-google-ads",
        "ui-icon-service-light-google-ads": this.icon === "service-light-google-ads",
        "ui-icon-service-twitter": this.icon === "service-twitter",
        "ui-icon-service-light-twitter": this.icon === "service-light-twitter",
        "ui-icon-service-email": this.icon === "service-email",
        "ui-icon-service-light-email": this.icon === "service-light-email",
        "ui-icon-service-messenger": this.icon === "service-messenger",
        "ui-icon-service-light-messenger": this.icon === "service-light-messenger",
        "ui-icon-service-estore": this.icon === "service-estore",
        "ui-icon-service-light-estore": this.icon === "service-light-estore",
        "ui-icon-service-imessage": this.icon === "service-imessage",
        "ui-icon-service-light-imessage": this.icon === "service-light-imessage",
        "ui-icon-service-webform": this.icon === "service-webform",
        "ui-icon-service-light-webform": this.icon === "service-light-webform",
        "ui-icon-service-sms": this.icon === "service-sms",
        "ui-icon-service-light-sms": this.icon === "service-light-sms",
        "ui-icon-service-call": this.icon === "service-call",
        "ui-icon-service-light-call": this.icon === "service-light-call",
        "ui-icon-service-call-up": this.icon === "service-call-up",
        "ui-icon-service-light-call-up": this.icon === "service-light-call-up",
        "ui-icon-service-infocall": this.icon === "service-infocall",
        "ui-icon-service-light-infocall": this.icon === "service-light-infocall",
        "ui-icon-service-site-b24": this.icon === "service-site-b24",
        "ui-icon-service-light-site-b24": this.icon === "service-light-site-b24",
        "ui-icon-service-site": this.icon === "service-site",
        "ui-icon-service-light-site": this.icon === "service-light-site",
        "ui-icon-service-calltracking": this.icon === "service-calltracking",
        "ui-icon-service-light-calltracking": this.icon === "service-light-calltracking",
        "ui-icon-service-telegram": this.icon === "service-telegram",
        "ui-icon-service-light-telegram": this.icon === "service-light-telegram",
        "ui-icon-service-bitrix24": this.icon === "service-bitrix24",
        "ui-icon-service-light-bitrix24": this.icon === "service-light-bitrix24",
        "ui-icon-service-groupme": this.icon === "service-groupme",
        "ui-icon-service-light-groupme": this.icon === "service-light-groupme",
        "ui-icon-service-crm": this.icon === "service-crm",
        "ui-icon-service-light-crm": this.icon === "service-light-crm",
        "ui-icon-service-lead": this.icon === "service-lead",
        "ui-icon-service-light-lead": this.icon === "service-light-lead",
        "ui-icon-service-deal": this.icon === "service-deal",
        "ui-icon-service-light-deal": this.icon === "service-light-deal",
        "ui-icon-service-campaign": this.icon === "service-campaign",
        "ui-icon-service-light-campaign": this.icon === "service-light-campaign",
        "ui-icon-service-chatbot": this.icon === "service-chatbot",
        "ui-icon-service-light-chatbot": this.icon === "service-light-chatbot",
        "ui-icon-service-common": this.icon === "service-common",
        "ui-icon-service-light-common": this.icon === "service-light-common",
        "ui-icon-service-g-assistant": this.icon === "service-g-assistant",
        "ui-icon-service-light-g-assistant": this.icon === "service-light-g-assistant",
        "ui-icon-service-microsoft": this.icon === "service-microsoft",
        "ui-icon-service-light-microsoft": this.icon === "service-light-microsoft",
        "ui-icon-service-office365": this.icon === "service-office365",
        "ui-icon-service-light-office365": this.icon === "service-light-office365",
        "ui-icon-service-skype": this.icon === "service-skype",
        "ui-icon-service-light-skype": this.icon === "service-light-skype",
        "ui-icon-service-webchat": this.icon === "service-webchat",
        "ui-icon-service-light-webchat": this.icon === "service-light-webchat",
        "ui-icon-service-directline": this.icon === "service-directline",
        "ui-icon-service-light-directline": this.icon === "service-light-directline",
        "ui-icon-service-envelope": this.icon === "service-envelope",
        "ui-icon-service-light-envelope": this.icon === "service-light-envelope",
        "ui-icon-service-fb-messenger": this.icon === "service-fb-messenger",
        "ui-icon-service-light-fb-messenger": this.icon === "service-light-fb-messenger",
        "ui-icon-service-fb-adds": this.icon === "service-fb-adds",
        "ui-icon-service-light-fb-adds": this.icon === "service-light-fb-adds",
        "ui-icon-service-outlook": this.icon === "service-outlook",
        "ui-icon-service-light-outlook": this.icon === "service-light-outlook",
        "ui-icon-service-vk": this.icon === "service-vk",
        "ui-icon-service-light-vk": this.icon === "service-light-vk",
        "ui-icon-service-vk-adds": this.icon === "service-vk-adds",
        "ui-icon-service-light-vk-adds": this.icon === "service-light-vk-adds",
        "ui-icon-service-vk-order": this.icon === "service-vk-order",
        "ui-icon-service-light-vk-order": this.icon === "service-light-vk-order",
        "ui-icon-service-fb": this.icon === "service-fb",
        "ui-icon-service-light-fb": this.icon === "service-light-fb",
        "ui-icon-service-fb-comments": this.icon === "service-fb-comments",
        "ui-icon-service-light-fb-comments": this.icon === "service-light-fb-comments",
        "ui-icon-service-slack": this.icon === "service-slack",
        "ui-icon-service-light-slack": this.icon === "service-light-slack",
        "ui-icon-service-viber": this.icon === "service-viber",
        "ui-icon-service-light-viber": this.icon === "service-light-viber",
        "ui-icon-service-kik": this.icon === "service-kik",
        "ui-icon-service-light-kik": this.icon === "service-light-kik",
        "ui-icon-service-apple": this.icon === "service-apple",
        "ui-icon-service-light-apple": this.icon === "service-light-apple",
        "ui-icon-service-universal": this.icon === "service-universal",
        "ui-icon-service-light-universal": this.icon === "service-light-universal",
        "ui-icon-service-organic": this.icon === "service-organic",
        "ui-icon-service-light-organic": this.icon === "service-light-organic",
        "ui-icon-service-telephonybot": this.icon === "service-telephonybot",
        "ui-icon-service-light-telephonybot": this.icon === "service-light-telephonybot",
        "ui-icon-service-whatsapp": this.icon === "service-whatsapp",
        "ui-icon-service-light-whatsapp": this.icon === "service-light-whatsapp",
        "ui-icon-service-wechat": this.icon === "service-wechat",
        "ui-icon-service-light-wechat": this.icon === "service-light-wechat",
        "ui-icon-service-avito": this.icon === "service-avito",
        "ui-icon-service-light-avito": this.icon === "service-light-avito",
        "ui-icon-service-mailru": this.icon === "service-mailru",
        "ui-icon-service-light-mailru": this.icon === "service-light-mailru",
        "ui-icon-service-sberbank": this.icon === "service-sberbank",
        "ui-icon-service-light-sberbank": this.icon === "service-light-sberbank",
        "ui-icon-service-green-sberbank": this.icon === "service-green-sberbank",
        "ui-icon-service-ok": this.icon === "service-ok",
        "ui-icon-service-light-ok": this.icon === "service-light-ok",
        "ui-icon-service-ya-toloka": this.icon === "service-ya-toloka",
        "ui-icon-service-rest-contact-center": this.icon === "service-rest-contact-center",
        "ui-icon-service-light-rest-contact-center": this.icon === "service-light-rest-contact-center",
        "ui-icon-service-audio-infocall": this.icon === "service-audio-infocall",
        "ui-icon-service-light-audio-infocall": this.icon === "service-light-audio-infocall",
        "ui-icon-service-olx": this.icon === "service-olx",
        "ui-icon-service-light-olx": this.icon === "service-light-olx",
        "ui-icon-service-zoom": this.icon === "service-zoom",
        "ui-icon-service-light-zoom": this.icon === "service-light-zoom",
        "ui-icon-service-blue-zoom": this.icon === "service-blue-zoom",
        "ui-icon-service-livechat-24": this.icon === "service-livechat-24",
        "ui-icon-service-widget": this.icon === "service-widget",
        "ui-icon-service-light-widget": this.icon === "service-light-widget",
        "ui-icon-service-wheel": this.icon === "service-wheel",
        "ui-icon-service-light-wheel": this.icon === "service-light-wheel",
        "ui-icon-service-play": this.icon === "service-play",
        "ui-icon-service-light-play": this.icon === "service-light-play",
        "ui-icon-service-other": this.icon === "service-other",
        "ui-icon-service-light-other": this.icon === "service-light-other",
        "ui-icon-service-cart": this.icon === "service-cart",
        "ui-icon-service-light-cart": this.icon === "service-light-cart",
        "ui-icon-service-add": this.icon === "service-add",
        "ui-icon-service-light-add": this.icon === "service-light-add",
        "ui-icon-service-arrows": this.icon === "service-arrows",
        "ui-icon-service-light-arrows": this.icon === "service-light-arrows",
        "ui-icon-service-call-in": this.icon === "service-call-in",
        "ui-icon-service-light-call-in": this.icon === "service-light-call-in",
        "ui-icon-service-call-out": this.icon === "service-call-out",
        "ui-icon-service-light-call-out": this.icon === "service-light-call-out"
      };
    }
  },
  props: {
    icon: {
      type: String,
      default: "file-empty"
    }
  },
  name: "bx-icon"
}, me = /* @__PURE__ */ a("i", null, null, -1), be = [
  me
];
function pe(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-icon", l.classList])
  }, be, 2);
}
const fi = /* @__PURE__ */ v(fe, [["render", pe]]);
const ye = {
  emits: ["change", "click-after", "click-before", "update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    color: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    inline: {
      type: Boolean,
      default: !1
    },
    noBorder: {
      type: Boolean,
      default: !1
    },
    underline: {
      type: Boolean,
      default: !1
    },
    noPadding: {
      type: Boolean,
      default: !1
    },
    round: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: ""
    },
    tagColor: {
      type: String,
      default: "default"
    },
    beforeIcon: {
      type: String,
      default: ""
    },
    beforeExt: {
      type: Boolean,
      default: !1
    },
    beforeButton: {
      type: Boolean,
      default: !1
    },
    afterIcon: {
      type: String,
      default: ""
    },
    afterExt: {
      type: Boolean,
      default: !1
    },
    afterButton: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-input"
}, _e = ["value", "placeholder", "disabled"];
function ke(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-ctl ui-ctl-textbox ui-ctl-active ui-ctl-hover", {
      "ui-ctl-lg": e.size === "lg",
      "ui-ctl-md": e.size === "md",
      "ui-ctl-sm": e.size === "sm",
      "ui-ctl-xs": e.size === "xs",
      "ui-ctl-success": e.color === "success",
      "ui-ctl-warning": e.color === "warning",
      "ui-ctl-danger": e.color === "danger",
      "ui-ctl-before-icon": e.beforeIcon && !e.beforeExt,
      "ui-ctl-ext-before-icon": e.beforeIcon && e.beforeExt,
      "ui-ctl-after-icon": e.afterIcon && !e.afterExt,
      "ui-ctl-ext-after-icon": e.afterIcon && e.afterExt,
      "ui-ctl-inline": e.inline,
      "ui-ctl-no-border": e.noBorder,
      "ui-ctl-underline": e.underline,
      "ui-ctl-no-padding": e.noPadding,
      "ui-ctl-round": e.round
    }]),
    style: k({
      "max-width": this.width || "initial",
      width: this.width || "auto"
    })
  }, [
    e.beforeIcon ? (o(), B(w(e.beforeButton ? "button" : "div"), {
      key: 0,
      class: u({
        "ui-ctl-before": !e.beforeExt,
        "ui-ctl-ext-before": e.beforeExt,
        "ui-ctl-icon-search": e.beforeIcon === "search",
        "ui-ctl-icon-calendar": e.beforeIcon === "calendar",
        "ui-ctl-icon-dots": e.beforeIcon === "dots",
        "ui-ctl-icon-phone": e.beforeIcon === "phone",
        "ui-ctl-icon-mail": e.beforeIcon === "mail",
        "ui-ctl-icon-clock": e.beforeIcon === "clock",
        "ui-ctl-icon-angle": e.beforeIcon === "angle",
        "ui-ctl-icon-clear": e.beforeIcon === "clear",
        "ui-ctl-icon-loader": e.beforeIcon === "loader"
      }),
      onClick: i[0] || (i[0] = (s) => t.$emit("click-before"))
    }, null, 8, ["class"])) : m("", !0),
    e.afterIcon ? (o(), B(w(e.afterButton ? "button" : "div"), {
      key: 1,
      class: u({
        "ui-ctl-after": !e.afterExt,
        "ui-ctl-ext-after": e.afterExt,
        "ui-ctl-icon-search": e.afterIcon === "search",
        "ui-ctl-icon-calendar": e.afterIcon === "calendar",
        "ui-ctl-icon-dots": e.afterIcon === "dots",
        "ui-ctl-icon-phone": e.afterIcon === "phone",
        "ui-ctl-icon-mail": e.afterIcon === "mail",
        "ui-ctl-icon-clock": e.afterIcon === "clock",
        "ui-ctl-icon-angle": e.afterIcon === "angle",
        "ui-ctl-icon-clear": e.afterIcon === "clear",
        "ui-ctl-icon-loader": e.afterIcon === "loader"
      }),
      onClick: i[1] || (i[1] = (s) => t.$emit("click-after"))
    }, null, 8, ["class"])) : m("", !0),
    e.tag ? (o(), r("div", {
      key: 2,
      class: u(["ui-ctl-tag", {
        "ui-ctl-tag-success": e.tagColor === "success",
        "ui-ctl-tag-primary": e.tagColor === "primary",
        "ui-ctl-tag-danger": e.tagColor === "danger",
        "ui-ctl-tag-warning": e.tagColor === "warning"
      }])
    }, f(e.tag), 3)) : m("", !0),
    a("input", {
      type: "text",
      class: "ui-ctl-element",
      value: e.modelValue,
      placeholder: e.placeholder,
      disabled: e.disabled,
      onChange: i[2] || (i[2] = (s) => t.$emit("change", s.target.value)),
      onInput: i[3] || (i[3] = (s) => t.$emit("update:modelValue", s.target.value))
    }, null, 40, _e)
  ], 6);
}
const mi = /* @__PURE__ */ v(ye, [["render", ke]]), xe = {
  computed: {
    isTagIcon() {
      return this.slotType === "input" && this.type === "text" || this.slotType === "default" ? "button" : "div";
    }
  },
  emits: ["click", "update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    slotType: {
      type: String,
      default: "input"
    },
    type: {
      type: String,
      default: "date"
    },
    after: {
      type: String,
      default: "after"
    },
    width: {
      type: String,
      default: ""
    }
  },
  name: "bx-input-date"
}, Be = ["value"], we = ["type", "value"];
function Se(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-ctl", {
      "ui-ctl-date": e.type === "date",
      "ui-ctl-time": e.type === "time",
      "ui-ctl-datetime": e.type === "datetime",
      "ui-ctl-after-icon": e.after === "after",
      "ui-ctl-ext-after-icon": e.after === "ext-after"
    }]),
    style: k({
      width: this.width || null,
      "max-width": this.width || null
    })
  }, [
    (o(), B(w(l.isTagIcon), {
      class: u(["ui-ctl-icon-calendar", {
        "ui-ctl-after": e.after === "after",
        "ui-ctl-ext-after": e.after === "ext-after"
      }]),
      onClick: i[0] || (i[0] = (s) => t.$emit("click"))
    }, null, 8, ["class"])),
    e.slotType === "select" ? (o(), r("select", {
      key: 0,
      class: "ui-ctl-element",
      value: e.modelValue,
      onChange: i[1] || (i[1] = (s) => t.$emit("update:modelValue", s.target.value))
    }, [
      g(t.$slots, "default")
    ], 40, Be)) : e.slotType === "input" ? (o(), r("input", {
      key: 1,
      class: "ui-ctl-element",
      type: e.type === "datetime" ? "datetime-local" : e.type,
      value: e.modelValue,
      onInput: i[2] || (i[2] = (s) => t.$emit("update:modelValue", s.target.value))
    }, null, 40, we)) : m("", !0)
  ], 6);
}
const bi = /* @__PURE__ */ v(xe, [["render", Se]]);
const Ce = {
  methods: {
    getName(t) {
      return `${t.name} (${O(t.size)})`;
    },
    onInput(t) {
      this.$emit("input", [...t.target.files]);
    },
    onChange(t) {
      this.$emit("change", [...t.target.files]);
    },
    onDelete(t) {
      this.$emit("delete", t);
    }
  },
  computed: {
    title() {
      return this.disabled ? "" : this.value.length ? this.value.map((t) => t.name).join(`
`) : this.multiple ? "\u0424\u0430\u0439\u043B\u044B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B." : "\u0424\u0430\u0439\u043B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D.";
    }
  },
  data() {
    return {
      placeholder: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B \u0438\u043B\u0438 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443"
    };
  },
  emits: ["change", "delete", "input"],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "drop"
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-input-file"
}, Ie = { class: "drag-n-drop" }, Xe = ["title"], Ae = ["multiple", "disabled"], ze = { class: "ui-ctl-label-text" }, Pe = ["title"], Ve = ["multiple", "disabled"], Ee = { class: "ui-ctl-label-text" }, Me = ["title"], Oe = { class: "ui-ctl-label-text" }, Le = /* @__PURE__ */ a("small", null, "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E drag'n'drop", -1), je = ["multiple", "disabled"], De = {
  key: 3,
  class: "drag-n-drop__list"
}, Re = { class: "drag-n-drop__name" }, Te = ["onClick"];
function We(t, i, e, n, c, l) {
  return o(), r("div", Ie, [
    e.type === "button" ? (o(), r("label", {
      key: 0,
      class: u(["ui-ctl ui-ctl-file-btn", { "bx-input-file-disabled": e.disabled }]),
      title: l.title
    }, [
      a("input", {
        class: "ui-ctl-element",
        type: "file",
        multiple: e.multiple,
        disabled: e.disabled,
        onInput: i[0] || (i[0] = (...s) => l.onInput && l.onInput(...s)),
        onChange: i[1] || (i[1] = (...s) => l.onChange && l.onChange(...s))
      }, null, 40, Ae),
      a("div", ze, [
        g(t.$slots, "default", {}, () => [
          I(f(c.placeholder), 1)
        ])
      ])
    ], 10, Xe)) : e.type === "link" ? (o(), r("label", {
      key: 1,
      class: u(["ui-ctl ui-ctl-file-link", { "bx-input-file-disabled": e.disabled }]),
      title: l.title
    }, [
      a("input", {
        class: "ui-ctl-element",
        type: "file",
        multiple: e.multiple,
        disabled: e.disabled,
        onInput: i[2] || (i[2] = (...s) => l.onInput && l.onInput(...s)),
        onChange: i[3] || (i[3] = (...s) => l.onChange && l.onChange(...s))
      }, null, 40, Ve),
      a("div", Ee, [
        g(t.$slots, "default", {}, () => [
          I(f(c.placeholder), 1)
        ])
      ])
    ], 10, Pe)) : e.type === "drop" ? (o(), r("label", {
      key: 2,
      class: u(["ui-ctl ui-ctl-file-drop", { "bx-input-file-disabled": e.disabled }]),
      title: l.title
    }, [
      a("div", Oe, [
        g(t.$slots, "default", {}, () => [
          a("span", null, f(c.placeholder), 1),
          Le
        ])
      ]),
      a("input", {
        class: "ui-ctl-element",
        type: "file",
        multiple: e.multiple,
        disabled: e.disabled,
        onInput: i[4] || (i[4] = (...s) => l.onInput && l.onInput(...s)),
        onChange: i[5] || (i[5] = (...s) => l.onChange && l.onChange(...s))
      }, null, 40, je)
    ], 10, Me)) : m("", !0),
    e.value.length ? (o(), r("ul", De, [
      (o(!0), r(X, null, A(e.value, (s, d) => (o(), r("li", {
        key: d,
        class: "drag-n-drop__file"
      }, [
        a("span", Re, f(l.getName(s)), 1),
        a("span", {
          class: "drag-n-drop__delete",
          onClick: (h) => l.onDelete(d)
        }, null, 8, Te)
      ]))), 128))
    ])) : m("", !0)
  ]);
}
const pi = /* @__PURE__ */ v(Ce, [["render", We]]), Fe = {
  methods: {
    onClick() {
      this.$BX24.openLink(this.href, this.$refs.link.target);
    }
  },
  computed: {
    portal() {
      return this.$BX24.getDomain(!0);
    }
  },
  inject: ["$BX24"],
  props: {
    href: {
      type: String,
      required: !0
    }
  },
  name: "bx-link"
}, Ue = ["href"];
function Ne(t, i, e, n, c, l) {
  return o(), r("a", {
    ref: "link",
    href: l.portal + e.href,
    target: "_blank",
    onClick: i[0] || (i[0] = S((...s) => l.onClick && l.onClick(...s), ["left", "prevent"]))
  }, [
    g(t.$slots, "default")
  ], 8, Ue);
}
const yi = /* @__PURE__ */ v(Fe, [["render", Ne]]), Ke = {
  computed: {
    width() {
      return `${this.progress}%`;
    },
    classList() {
      return {
        "ui-progressbar-lg": this.size === "lg",
        "ui-progressbar-md": this.size === "md",
        "ui-progressbar-primary": this.color === "primary",
        "ui-progressbar-success": this.color === "success",
        "ui-progressbar-warning": this.color === "warning",
        "ui-progressbar-danger": this.color === "danger",
        "ui-progressbar-bg": this.bg,
        "ui-progressbar-column": this.column
      };
    }
  },
  props: {
    progress: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: "md"
    },
    color: {
      type: String,
      default: "primary"
    },
    textBefore: {
      type: String,
      default: ""
    },
    textAfter: {
      type: String,
      default: ""
    },
    bg: {
      type: Boolean,
      default: !1
    },
    column: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-progressbar"
}, Ge = {
  key: 0,
  class: "ui-progressbar-text-before"
}, qe = { class: "ui-progressbar-track" }, He = {
  key: 1,
  class: "ui-progressbar-text-after"
};
function $e(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-progressbar", l.classList])
  }, [
    e.textBefore ? (o(), r("div", Ge, f(e.textBefore), 1)) : m("", !0),
    a("div", qe, [
      a("div", {
        class: "ui-progressbar-bar",
        style: k({ width: l.width })
      }, null, 4)
    ]),
    e.textAfter ? (o(), r("div", He, f(e.textAfter), 1)) : m("", !0)
  ], 2);
}
const _i = /* @__PURE__ */ v(Ke, [["render", $e]]);
const Je = {
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  },
  emits: ["update:modelValue"],
  props: {
    value: {
      type: [Boolean, String, Array, Object],
      default: ""
    },
    modelValue: {
      type: [Boolean, String, Array, Object],
      default: ""
    },
    width: {
      type: String,
      default: "320px"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-radio"
}, Qe = ["checked", "value", "disabled"], Ye = { class: "ui-ctl-label-text" };
function Ze(t, i, e, n, c, l) {
  return o(), r("label", {
    class: "ui-ctl ui-ctl-radio",
    style: k({ width: e.width })
  }, [
    a("input", {
      class: "ui-ctl-element",
      type: "radio",
      checked: l.isChecked,
      value: e.value,
      disabled: e.disabled,
      onChange: i[0] || (i[0] = (s) => t.$emit("update:modelValue", s.target.value))
    }, null, 40, Qe),
    a("div", Ye, [
      g(t.$slots, "default")
    ])
  ], 4);
}
const ki = /* @__PURE__ */ v(Je, [["render", Ze]]), ei = {
  emits: ["click", "update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "select"
    }
  },
  name: "bx-select"
}, ii = { class: "ui-ctl ui-ctl-after-icon ui-ctl-dropdown" }, ti = ["value"], ni = ["value"];
function si(t, i, e, n, c, l) {
  return o(), r("div", ii, [
    (o(), B(w(e.type === "select" ? "div" : "button"), {
      class: "ui-ctl-after ui-ctl-icon-angle",
      onClick: i[0] || (i[0] = (s) => t.$emit("click"))
    })),
    e.type === "select" ? (o(), r("select", {
      key: 0,
      class: "ui-ctl-element",
      value: e.modelValue,
      onChange: i[1] || (i[1] = (s) => t.$emit("update:modelValue", s.target.value))
    }, [
      g(t.$slots, "default")
    ], 40, ti)) : e.type === "search" ? (o(), r("input", {
      key: 1,
      type: "text",
      class: "ui-ctl-element",
      value: e.modelValue,
      onInput: i[2] || (i[2] = (s) => t.$emit("update:modelValue", s.target.value))
    }, null, 40, ni)) : m("", !0)
  ]);
}
const xi = /* @__PURE__ */ v(ei, [["render", si]]), ci = {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    resize: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  name: "bx-textarea"
}, li = ["value", "placeholder", "disabled"];
function oi(t, i, e, n, c, l) {
  return o(), r("div", {
    class: u(["ui-ctl ui-ctl-textarea", {
      "ui-ctl-no-resize": e.resize === "no",
      "ui-ctl-resize-y": e.resize === "y",
      "ui-ctl-resize-x": e.resize === "x"
    }])
  }, [
    a("textarea", {
      class: "ui-ctl-element",
      value: e.modelValue,
      placeholder: e.placeholder,
      disabled: e.disabled,
      onInput: i[0] || (i[0] = (s) => t.$emit("update:modelValue", s.target.value))
    }, null, 40, li)
  ], 2);
}
const Bi = /* @__PURE__ */ v(ci, [["render", oi]]);
export {
  ai as Bitrix24,
  ui as BxAlert,
  di as BxButton,
  hi as BxButtonWrapper,
  gi as BxCheckbox,
  vi as BxEntitySelector,
  fi as BxIcon,
  mi as BxInput,
  bi as BxInputDate,
  pi as BxInputFile,
  yi as BxLink,
  _i as BxProgressbar,
  ki as BxRadio,
  xi as BxSelect,
  Bi as BxTextarea
};
